import { Box } from 'grommet';
import React, { useContext, useState } from 'react';
import Button from '../../Button';
import Modal from '../../Modal';
import { NotificationsContext } from '../../NotificationsProvider';
import StatusMessage from '../../StatusMessage';
import CustomerSearch from '../../CustomerSearch';

const ChangeCustomerModal = ({
    transactionId,
    currentCustomerId,
    onClose,
    onSuccess
}) => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const notificationCtx = useContext(NotificationsContext);

    const handleConfirm = () => {
        if (!selectedCustomer) return;

        setLoading(true);
        setError(null);

        fetch(`/api/transactions/${transactionId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                recipient_id: selectedCustomer.id
            }),
        })
            .then(async (response) => {
                let data;
                try {
                    data = await response.json();
                } catch {
                    data = {};
                }
                if (!response.ok) {
                    throw { message: data?.message || data?.error || `Request failed (${response.status})` };
                }
                return data;
            })
            .then((data) => {
                setLoading(false);
                notificationCtx.showNotification({ type: 'success', message: 'Customer updated successfully.' });
                if (onSuccess) onSuccess(data);
                onClose();
            })
            .catch((err) => {
                setLoading(false);
                setError({
                    message: err?.message || err?.error || 'Unable to update customer. Please try again.'
                });
            });
    };

    return (
        <Modal
            onClose={onClose}
            contentProps={{
                width: 'medium',
                pad: undefined
            }}
            sectionProps={{
                width: 'medium',
                hideBorder: true,
                fill: 'horizontal',
                headerProps: { pad: { bottom: 'small', horizontal: 'xsmall' } }
            }}
            title="Change customer"
        >
            <Box fill='horizontal' pad={{ horizontal: "small" }}>
                {error && (
                    <Box pad={{ bottom: 'small' }}>
                        <StatusMessage apiError={error} />
                    </Box>
                )}
                <CustomerSearch
                    // One container around the search and its results, the same
                    // treatment the collect deposit drawer uses. Unframed, the
                    // input carries its own border while the list below has none,
                    // so the two read as separate objects.
                    framed
                    onSelect={setSelectedCustomer}
                    excludeCustomerId={currentCustomerId}
                />
                <Box
                    justify="end"
                    margin={{ top: 'medium', bottom: 'small' }}
                    direction="row"
                    align="center"
                    gap="small"
                >
                    <Button
                        secondary
                        onClick={onClose}
                        label="Cancel"
                        disabled={loading}
                    />
                    <Button
                        event={{ section: 'change_customer_modal', element: 'confirm' }}
                        primary
                        onClick={handleConfirm}
                        disabled={!selectedCustomer || loading}
                        label={loading ? "Saving..." : "Confirm"}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default ChangeCustomerModal;
